import { Type } from '@angular/core';

export const /** @type {?} */ EMPTY_VAL = { __isEmpty: true };
/**
 * @param {?} val
 * @return {?}
 */
export function isEmptyVal(val: any): val is typeof EMPTY_VAL {
  return !!val && !!val.__isEmpty;
}
/**
 * @param {?} protoType
 * @param {?} type
 * @return {?}
 */
export function hasTypeAsProto(protoType: Type<any>, type: Type<any>): boolean {
  const /** @type {?} */ proto = Object.getPrototypeOf(type);

  if (proto === protoType) {
    return true;
  }

  if (proto) {
    return hasTypeAsProto(protoType, proto);
  }

  return false;
}
